import React, { useEffect } from "react";
import Header from "../components/Header";
import { FaInfoCircle, FaTimes, FaExternalLinkAlt } from "react-icons/fa";
import api from "../services/Api";

const Notification = () => {
  const sendNotification = async () => {
    try {
      const response = await api.post('/notifications/send');

      console.log('Notification sent:', response.data);
    } catch (error) {
      console.error('Error sending notification:', error);
    }
  };

  useEffect(() => {
    sendNotification(); 
  }, []);

  return (
    <div className="px-4 pt-3 sm:ml-64 w-[80%] bg-[#F4F5F6]">
      <div className="">
        <Header />
        <div className="mb-2">
            <p className="font-sans font-normal text-xs text-[#191B1C]">
              Notification<span className="font-sans block text-[10px] text-[#626C70]">
             Home &gt; Notification
            </span>
            </p>
          </div>
        <div className="px-10 py-8 rounded-2xl bg-[#FFFFFF]">
          <div className="flex items-start bg-white border-l-4 border-blue-300 p-4 rounded-md shadow-md mb-4">
            <div className="mr-3 mt-1">
              <FaInfoCircle className="text-green-500" />
            </div>
            <div className="flex-1">
              <h4 className="font-bold text-sm">Note</h4>
              <p className="text-xs">
                This product is under active development and is available in a
                Private Beta.
              </p>
              <button className="ml-4 border bg-transparent text-xs rounded p-2 border-gray-500 hover:border-gray-700">
                Button
              </button>
              <button className="ml-4 text-xs text-blue-500">Button</button>
            </div>
            <button className="ml-4 text-gray-500 hover:text-gray-700">
              <FaTimes />
            </button>
          </div>

          {Array(2)
            .fill("")
            .map((_, index) => (
              <div
                key={index}
                className="flex items-start bg-white p-4 rounded-md shadow-md mb-4"
              >
                <div className="flex-1">
                  <p className="text-xs">
                    This product is under active development and is available in
                    a Private Beta.
                  </p>
                </div>
                <button className="ml-4 text-gray-500 hover:text-gray-700">
                  <FaTimes />
                </button>
              </div>
            ))}

          <div className="flex items-start bg-white p-4 rounded-md shadow-md mb-4">
            <div className="mr-3 mt-1">
              <FaInfoCircle className="text-gray-500" />
            </div>
            <div className="flex-1">
              <h4 className="text-xs">
                This product is under active development and is available in a
                Private Beta.
              </h4>
              <button className="ml-4 border bg-transparent inline-flex text-xs rounded p-2 border-gray-500 hover:border-gray-700">
                Signup! <FaExternalLinkAlt className="mx-2 my-auto" />
              </button>
            </div>
          </div>

          <div className="flex items-start bg-white border-l-4 border-red-400 p-4 rounded-md shadow-md mb-4">
            <div className="mr-3 mt-1">
              <FaInfoCircle className="text-red-500" />
            </div>
            <div className="flex-1">
              <h4 className="text-xs">
                This product is under active development and is available in a
                Private Beta.
              </h4>
            </div>
          </div>

          <div className="flex items-start bg-white border-l-4 border-green-400 p-4 rounded-md shadow-md mb-4">
            <div className="flex-1">
              <p className="text-xs">
                This product is under active development and is available in a
                Private Beta.
              </p>
            </div>
            <button className="ml-4 text-gray-500 hover:text-gray-700">
              <FaTimes />
            </button>
          </div>

          <div className="flex items-start bg-white p-4 rounded-md shadow-md mb-4">
            <div className="flex-1">
              <p className="text-xs">
                This product is under active development and is available in a
                Private Beta.
              </p>
              <button className="ml-4 border bg-transparent text-xs rounded p-2 border-gray-500 hover:border-gray-700">
                Button
              </button>
              <button className="ml-4 border bg-transparent text-xs rounded p-2 border-gray-500 hover:border-gray-700">
                Button
              </button>
            </div>
            <button className="ml-4 text-gray-500 hover:text-gray-700">
              <FaTimes />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notification;
